import { useEffect } from 'react';
import { CepChartCategoryType } from 'basics/enums/cep.enums';
import useGetCepsByMonthAndProductOrTaLazyQuery from 'basics/graphql/queries/getCepsByMonthAndProductOrTaLazy';
import useGetCepsCountByMonthAndProductOrTaLazyQuery
  from 'basics/graphql/queries/getCepsCountByMonthAndProductOrTaLazy';
import useGetCustomerEngagementPlanningsPercentageOfApprovedLazyQuery
  from 'basics/graphql/queries/getCepsPercentageOfApprovedLazy';
import useGetCountOfTacticsChannelsLazyQuery from 'basics/graphql/queries/getСountOfTacticsChannelsLazy';
import { DashboardFilter } from 'generated/maya.types';

const useAdminDashboardCharts = (filters?: DashboardFilter) => {
  const {
    getCepsByMonthAndProductOrTaLazyQuery: getCepsByMonthAndProduct,
    data: cepsByMonthAndProduct,
    loading: cepsByMonthAndProductLoading,
  } = useGetCepsByMonthAndProductOrTaLazyQuery();
  const {
    getCepsByMonthAndProductOrTaLazyQuery: getCepsByMonthAndTa,
    data: cepsByMonthAndTa,
    loading: cepsByMonthAndTaLoading,
  } = useGetCepsByMonthAndProductOrTaLazyQuery();
  const {
    getCepsCountByMonthAndProductOrTaLazyQuery: getCepsCountByMonthAndProduct,
    data: cepsCountByMonthAndProduct,
    loading: cepsCountByMonthAndProductLoading,
  } = useGetCepsCountByMonthAndProductOrTaLazyQuery();
  const {
    getCepsCountByMonthAndProductOrTaLazyQuery: getCepsCountByMonthAndTa,
    data: cepsCountByMonthAndTa,
    loading: cepsCountByMonthAndTaLoading,
  } = useGetCepsCountByMonthAndProductOrTaLazyQuery();
  const {
    getCepsPercentageOfApprovedLazyQuery: getCepsPercentageOfApproved,
    data: cepsPercentageOfApproved,
    loading: cepsPercentageOfApprovedLoading,
  } = useGetCustomerEngagementPlanningsPercentageOfApprovedLazyQuery();
  const {
    getCountOfTacticsChannelsLazyQuery: getCountOfTacticsChannels,
    data: countOfCepTacticsChannels,
    loading: countOfCepTacticsChannelsLoading,
  } = useGetCountOfTacticsChannelsLazyQuery();

  useEffect(() => {
    if (filters) {
      getCepsByMonthAndProduct({ variables: { filters, category: CepChartCategoryType.product } });
      getCepsByMonthAndTa({ variables: { filters, category: CepChartCategoryType.therapeuticArea } });
      getCepsCountByMonthAndProduct({ variables: { filters, category: CepChartCategoryType.product } });
      getCepsCountByMonthAndTa({ variables: { filters, category: CepChartCategoryType.therapeuticArea } });
      getCepsPercentageOfApproved({ variables: { filters } });
      getCountOfTacticsChannels({ variables: { filters } });
    }
  }, [
    filters,
    getCepsByMonthAndProduct,
    getCepsByMonthAndTa,
    getCepsCountByMonthAndProduct,
    getCepsCountByMonthAndTa,
    getCepsPercentageOfApproved,
    getCountOfTacticsChannels,
  ]);

  return {
    cepsByMonthAndProduct,
    cepsByMonthAndTa,
    cepsCountByMonthAndProduct,
    cepsCountByMonthAndTa,
    cepsPercentageOfApproved,
    countOfCepTacticsChannels,
    cepsByMonthAndProductLoading,
    cepsByMonthAndTaLoading,
    cepsCountByMonthAndProductLoading,
    cepsCountByMonthAndTaLoading,
    cepsPercentageOfApprovedLoading,
    countOfCepTacticsChannelsLoading,
  };
};

export default useAdminDashboardCharts;
